<template>
    <div class="text-center p-5">
        <h4>Thank You</h4>
        <p>A verification Email has been sent to your address</p>
        <b-button variant="secondary" @click="handleOK">Ok</b-button>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */

    methods: {
        handleOK() {
            this.$emit('thanked', true)
        },
    }, // End methods
}
</script>
